import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import {
    lazyTriggerAttachmentsChangedEvent,
    AttachmentStatusEnum,
    AttachmentDetails,
} from 'owa-addins-core';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import { lazyGetTypeOfAttachment } from 'owa-addins-common-utils';
import { isCloudyAttachmentType } from 'owa-attachment-model-store/lib/utils/isCloudyAttachment';

export default async function triggerAttachmentsChanged(
    composeId: string,
    attachmentStatus: AttachmentStatusEnum,
    attachment: AttachmentType
) {
    let attachmentDetail: AttachmentDetails = null;

    let url: string = undefined;

    let getTypeOfAttachment = await lazyGetTypeOfAttachment.import();

    // Access store and get AttachmentDetails object for "attachment".
    if (attachmentStatus === AttachmentStatusEnum.Added) {
        // Get attachment details from model.
        const attachmentModel = getAttachment(attachment.AttachmentId);
        if (isCloudyAttachmentType(attachmentModel.model)) {
            url = attachmentModel.model.AttachLongPathName;
        }
        if (attachmentModel && attachmentModel.model) {
            attachmentDetail = {
                id: attachment.AttachmentId.Id,
                name: attachmentModel.model.Name,
                contentType: attachmentModel.model.ContentType,
                size: attachmentModel.model.Size,
                attachmentType: getTypeOfAttachment(attachmentModel.model.__type),
                isInline: attachmentModel.model.IsInline,
                url: url,
            };
        }
    } else if (attachmentStatus === AttachmentStatusEnum.Deleted) {
        // Since attachment is already deleted, details are not present in model.
        // Get attachment details from AttachmentType object received.
        if (isCloudyAttachmentType(attachment)) {
            url = attachment.AttachLongPathName;
        }
        attachmentDetail = {
            id: attachment.AttachmentId.Id,
            name: attachment.Name,
            contentType: attachment.ContentType,
            size: attachment.Size,
            attachmentType: getTypeOfAttachment(attachment.__type),
            isInline: attachment.IsInline,
            url: url,
        };
    }

    let triggerAttachmentsChanged = await lazyTriggerAttachmentsChangedEvent.import();
    triggerAttachmentsChanged(composeId, attachmentStatus, attachmentDetail);
}
